import { translations } from 'translations';
import * as Yup from 'yup';

export const LoginFormValidationSchema = Yup.object().shape({
  email: Yup.string()
    .email(translations.ERRORS.VALID_EMAIL),
  password: Yup.string(),
  otp: Yup.string(),
});
